import React, { Fragment, useEffect, useState } from "react";
import { faTimes, faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Loader from "react-loader-spinner";
import swal from "sweetalert";
import GetStudentService from "../../../services/SchoolIT/GetStudentService";
import "./GoalChange.css";

const counselorLabel = (item) =>
  item?.counselor?.name ||
  item?.name ||
  [item?.first_name, item?.last_name].filter(Boolean).join(" ") ||
  item?.email ||
  "Counselor";

const counselorValue = (item) =>
  item?.counselor?.id || item?.id || "";

const GoalChange = ({ setOpenGoalChange }) => {
  const [counselor, setCounselor] = useState("");
  const [goalChange, setGoalChange] = useState("");
  const [messageText, setMessageText] = useState("");
  const [counselorList, setCounselorList] = useState([]);
  const [sending, setSending] = useState(false);
  const user =
    localStorage.getItem("user") && JSON.parse(localStorage.getItem("user"));

  const canSubmit = Boolean(
    counselor && goalChange.trim() && messageText.trim() && !sending
  );

  useEffect(() => {
    if (!user?.school_id) return;
    GetStudentService.getCounselorName("", "counselor", user.school_id)
      .then((data) => {
        setCounselorList(data?.data?.objects || data?.data?.result || []);
      })
      .catch(() => {
        setCounselorList([]);
      });
  }, [user?.school_id]);

  const sendGoalChangeRequest = () => {
    if (!canSubmit) return;
    const dstId = parseInt(counselor, 10);
    if (!dstId) {
      swal({
        text: "Please select a counselor.",
        icon: "warning",
        buttons: { OK: true },
      });
      return;
    }

    const keyword = goalChange.trim();
    const note = messageText.trim();
    const obj = {
      dst_id: [dstId],
      event_type: "school_it_counselor",
      message_body: `This is a request to goal change with keyword : ${keyword}\n\n${note}`,
    };

    setSending(true);
    GetStudentService.sendMessage(obj)
      .then((data) => {
        setGoalChange("");
        setMessageText("");
        setCounselor("");
        setOpenGoalChange(false);
        swal({
          text: data?.data?.Status || "Goal change request sent successfully.",
          icon: "success",
          buttons: { OK: true },
        });
      })
      .catch(() => {
        swal({
          text: "Unable to send goal change request. Please try again.",
          icon: "error",
          buttons: { OK: true },
        });
      })
      .finally(() => setSending(false));
  };

  return (
    <Fragment>
      <div
        className="profile-drawer-overlay"
        onClick={() => !sending && setOpenGoalChange(false)}
      />
      <aside className="profile-drawer" role="dialog" aria-labelledby="goal-change-title">
        <div className="profile-drawer-header">
          <h3 id="goal-change-title" className="profile-drawer-title">
            Request to change goal
          </h3>
          <button
            type="button"
            className="profile-drawer-close"
            onClick={() => setOpenGoalChange(false)}
            aria-label="Close"
            disabled={sending}
          >
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </div>

        <div className="profile-drawer-body">
          <div className="profile-drawer-field">
            <label className="profile-drawer-label" htmlFor="goal-change-counselor">
              To
            </label>
            <select
              id="goal-change-counselor"
              className="profile-drawer-select"
              value={counselor}
              onChange={(e) => setCounselor(e.target.value)}
              disabled={sending}
            >
              <option value="">Select Counselor</option>
              {counselorList.map((item, index) => (
                <option key={counselorValue(item) || index} value={counselorValue(item)}>
                  {counselorLabel(item)}
                </option>
              ))}
            </select>
          </div>

          <div className="profile-drawer-field">
            <label className="profile-drawer-label" htmlFor="goal-change-keyword">
              Goal Change
            </label>
            <input
              id="goal-change-keyword"
              className="profile-drawer-input"
              type="text"
              placeholder="Type a goal change keyword"
              value={goalChange}
              onChange={(e) => setGoalChange(e.target.value)}
              disabled={sending}
            />
          </div>

          <div className="profile-drawer-field">
            <label className="profile-drawer-label" htmlFor="goal-change-message">
              Message
            </label>
            <textarea
              id="goal-change-message"
              className="profile-drawer-textarea"
              placeholder="Add a note for your counselor"
              value={messageText}
              onChange={(e) => setMessageText(e.target.value)}
              disabled={sending}
            />
          </div>
        </div>

        <div className="profile-drawer-footer">
          <button
            type="button"
            className="admin-ccplus-btn ghost"
            onClick={() => setOpenGoalChange(false)}
            disabled={sending}
          >
            <FontAwesomeIcon icon={faTimes} />
            Cancel
          </button>
          <button
            type="button"
            className="admin-ccplus-btn primary"
            disabled={!canSubmit}
            onClick={sendGoalChangeRequest}
          >
            {sending ? (
              <Loader type="TailSpin" color="#fff" height={16} width={16} />
            ) : (
              <FontAwesomeIcon icon={faEnvelope} />
            )}
            {sending ? "Sending..." : "Change Goal Request"}
          </button>
        </div>
      </aside>
    </Fragment>
  );
};

export default GoalChange;
